import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import scrollToTop from '../../../hoc/scrollToTop';

import * as IBooks from '../../../../interfaces/merchants/resources/books';
import * as IInputs from '../../../../interfaces/merchants/resources/books/inputs';

import {
  clearBookingSchoolTimeSlot,
  inputBookingTargets,
  RestartReservationError,
} from '../../../../redux/actions/merchants/resources/books/inputs';
import { Dispatch } from '../../../../redux/reducers/merchants/resources/books/inputs';

import InputBookingTargetLessonSelector from './InputBookingTargetLessonSelector';

interface ElementProps {
  modelType: IBooks.ModelType;
  settings: IBooks.SettingBookingTargetsLesson;
  postable: boolean;
  renew: boolean;
  onSubmit: () => void;
  onRestart: () => void;
  withExpressFlow: boolean;
}

interface StateProps {
  inputs: IInputs.State;
}

interface DispatchProps {
  actions: {
    handleSubmit: (
      modelType: IBooks.ModelType,
      merchantId: string,
      resourceId: string,
      lesson: IBooks.Lesson,
      withExpressFlow: boolean,
      reservationId?: number,
    ) => Promise<void>;
  };
}

type Props = ElementProps & StateProps & DispatchProps & InjectedIntlProps;

class InputBookingTarget extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  private availableToUseSelectedLesson() {
    const {
      settings: { selectedLesson },
      inputs: { lesson },
      renew,
    } = this.props;
    if (renew) {
      return false;
    }
    if (!selectedLesson) {
      return false;
    }
    if (lesson) {
      return false;
    }
    return true;
  }

  public componentDidMount() {
    // query paramsで指定されたやつを使いたい場合がある。
    const {
      settings: { selectedLesson },
    } = this.props;
    if (!this.availableToUseSelectedLesson()) {
      return;
    }
    this.handleSubmit(selectedLesson!);
  }

  private async handleSubmit(lesson: IBooks.Lesson) {
    const {
      modelType,
      inputs,
      onSubmit,
      onRestart,
      withExpressFlow,
    } = this.props;
    try {
      await this.props.actions.handleSubmit(
        modelType,
        inputs.merchantId!,
        inputs.resourceId!,
        lesson,
        withExpressFlow,
        inputs.reservationId,
      );
      onSubmit();
    } catch (e) {
      if (e instanceof RestartReservationError) {
        onRestart();
      }
    }
  }

  public render() {
    if (this.availableToUseSelectedLesson()) {
      return null;
    }
    const { settings, postable } = this.props;
    return (
      <InputBookingTargetLessonSelector
        lessons={settings.lessons}
        postable={postable}
        onClick={this.handleSubmit}
      />
    );
  }
}

const mapStateProps = ({
  merchantsResourcesBooksInputs,
}: {
  merchantsResourcesBooksInputs: IInputs.State;
}): StateProps => ({
  inputs: merchantsResourcesBooksInputs,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: {
    handleSubmit: async (
      modelType: IBooks.ModelType,
      merchantId: string,
      resourceId: string,
      lesson: IBooks.Lesson,
      withExpressFlow: boolean,
      reservationId?: number,
    ) => {
      await clearBookingSchoolTimeSlot()(dispatch);
      await inputBookingTargets(
        modelType,
        merchantId,
        resourceId,
        { lesson },
        withExpressFlow,
        reservationId,
      )(dispatch);
    },
  },
});

export default connect(
  mapStateProps,
  mapDispatchToProps,
)(injectIntl(scrollToTop(InputBookingTarget)));
